<template>
  <div id="dc_mypage">
    <dd-header />
    <div class="wrapper">
      <div class="main_content">
        <dd-menu ref="menuRef"/>
        <div>
          <dd-sitemap
            :pageKey="pageKey"
            :pageList="pageList"
            :mapStyle="'topic_path'"
          />
          <h1>ニュース</h1>
          <p>
            {{newsText}}
          </p>
          <section class="infomation2">
            <h3>新規情報</h3>
            <ul>
              <li v-for="(news, index) in viewNewsList" class="news" :key="'news-' + index" :value="product" @click="setNewsMessage(news.opInfoBody)">
                <div>{{news.opInfoStartdt}}</div>
                <div>{{news.opInfoTitle}}</div>
              </li>
            </ul>
            <dd-pager
              :pageNo="pageNo"
              :dataCountPerPage="4"
              :totalDataCount="newsList ? newsList.length : 0"
              @paging="paging"
            />
          </section>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'

import Header from '../components/common/DcHeader'
import DcFooter from '../components/common/DcFooter'
import DDLeftMenu from '../components/top/DcLeftMenu'
import DcPager from '../components/common/DcPager'
import DcSiteMap from '../components/common/DcSiteMap'
import LoadingModal from '../../components/common/LoadingModal'

const NEWS_VIEW_SIZE = 4

export default {
  components: {
    'dd-header': Header,
    'dd-footer': DcFooter,
    'dd-menu': DDLeftMenu,
    'dd-loading-modal': LoadingModal,
    'dd-pager': DcPager,
    'dd-sitemap': DcSiteMap
  },
  data () {
    return {
      pageKey: 'dcNews',
      pageList: [
        {id: 'top', key: 'dcTop', title: 'トップページ', route: 'DcTop'},
        {id: 'news', key: 'dcNews', title: 'ニュース', route: 'dcNews'}
      ],
      newsText: 'mm/styleで取り扱います商品やサービス、運営サイトに関する最新情報などを掲載しております。',
      pageNo: 1
    }
  },
  computed: {
    ...mapState({
      newsList: state => state.newsList
    }),
    viewNewsList: function () {
      if (!this.newsList) return []
      let startIdx = (this.pageNo - 1) * NEWS_VIEW_SIZE
      let endIdx = this.pageNo * NEWS_VIEW_SIZE
      let list = this.newsList.filter(function (element, index) {
        return (index >= startIdx && index < endIdx)
      })
      return list
    }
  },
  methods: {
    ...mapActions({ getNewsList: 'loadNewsList' }),
    setNews: function (news) {
      this.newsText = news
    },
    paging: function (currentPageNo) {
      this.pageNo = currentPageNo
    },
    setNewsMessage: function (message) {
      this.newsText = message
    }
  },
  mounted: function () {
    this.$store.dispatch('loadNewsList', {reload: true})
  },
  created: function () {
  }
}
</script>
<style src="../css/dctop4.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcNews.vue